// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"544":"66f334c7","727":"bef23b8f","809":"4b95c6b5","866":"c489b46c","906":"46cc42f3"}[chunkId] + ".chunk.css";
};